import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Layout-only: gives the discount pages a "Discounts" crumb that links back to the list. */
export const Route = createFileRoute('/_authed/_active/s/$storeId/discounts')({
  staticData: { crumb: 'common:nav.discounts' },
  component: Outlet,
});
